import React from 'react';
import { Controller } from 'react-hook-form';

import { MezzaFormField, MezzaFormFieldProps } from '../MezzaForm';
import { inputLabels } from '../../../data/labels';
import Input from '../../Input/Input';

const Floor = ({ control }: MezzaFormFieldProps) => {
  return (
    <Controller
      control={control}
      name={MezzaFormField.FLOOR}
      render={({ field }) => (
        <Input
          id={MezzaFormField.FLOOR}
          value={field.value}
          setValue={field.onChange}
          label={inputLabels.floor}
        />
      )}
    />
  );
};

export default React.memo(Floor);
